<template>
    <div style="height: 100%">
        <slot
            :brief="brief"
            :is-loading="isLoading"
            :affiliate-links="mockAffiliateLinks"
            :discount-codes="mockDiscountCodes"
            :activation-fields="activationFields"
            :step="mockStep"
        />
    </div>
</template>

<script>
    import {message} from '@grininc/grin-ui';
    import BasePreviewProviderMixin from './mixins/BasePreviewProviderMixin';
    import ActivationApiMixin from './mixins/ActivationApiMixin';
    import MockBriefMixin from './mixins/MockBriefMixin';
    import MockStepMixin from './mixins/MockStepMixin';
    import MockConversionsMixin from './mixins/MockConversionsMixin';
    import {NAME_PERSONAL_INFO} from '../../../constants/activation-brief-steps';

    export default {
        name:   'ActivationPreviewProvider',
        mixins: [
            BasePreviewProviderMixin,
            ActivationApiMixin,
            MockBriefMixin,
            MockStepMixin,
            MockConversionsMixin,
        ],
        data() {
            return {
                brief:              null,
                activationFields:   [],
                isLoading:          false,
                mockStep:           {},
                mockAffiliateLinks: [],
                mockDiscountCodes:  [],
            };
        },
        created() {
            const activationId  = this.$route?.params?.activation_id;
            this.isLoading = true;

            Promise.resolve()
                .then(() => {
                    if (this.moduleName === NAME_PERSONAL_INFO) {
                        return this.fetchActivationFields(activationId);
                    }
                })
                .then((res) => {
                    if(res && res.data[0]) {
                        this.activationFields = res.data;
                    }
                    return this.fetchActivation(activationId, this.moduleName);
                })
                .then((res) => {
                    const brief = res.data[0];
                    this.mockStep = this.getMockStepState(this.moduleName, brief);
                    this.mockAffiliateLinks = this.getMockAffiliateLinks(brief);
                    this.mockDiscountCodes = this.getMockDiscountCodes(brief);
                    this.brief = this.buildMockBrief(this.moduleName, brief);
                })
                .catch(() => {
                    message.error('Something went wrong, please try again or contact support');
                })
                .then(() => {
                    this.isLoading = false;
                });

        },
    };
</script>
